import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { PaymentStatusView, useReservationPolling } from '../components/ReservationModal';
import { useI18n } from '../i18n/LanguageContext';

/** Where the card payment page sends people back to: /payment/return?ref=IZM-… */
export default function PaymentReturn() {
  const { t } = useI18n();
  const [params] = useSearchParams();
  const reference = params.get('ref');
  const { reservation, error } = useReservationPolling(reference, null);

  return (
    <section className="rsv-return">
      <div className="rsv-return-card">
        <h1 className="modal-title">{t('payment_return.title')}</h1>
        {reference ? (
          <PaymentStatusView reservation={reservation} error={error} />
        ) : (
          <p className="rsv-status-text">{t('payment_return.no_reference')}</p>
        )}
        <Link to="/" className="modal-btn modal-btn--ghost rsv-return-home">{t('payment_return.home')}</Link>
      </div>
    </section>
  );
}
